module.exports = __webpack_public_path__ + "toBride2-we-g-n.f5f38920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-g-n.jpg
// module id = tg1l
// module chunks = 0